import React, { useState } from "react";
import { Query } from "react-apollo";
import { gql } from "apollo-boost";
import { useTranslation } from "react-i18next";
import orderBy from "lodash/orderBy";

import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import ButtonGroup from "@material-ui/core/ButtonGroup";

import Loader from "../Loader";
import Dropdown from "../Dropdown";

const useStyles = makeStyles(theme => ({
  root: {
    "& > *:not(:first-child)": {
      marginLeft: theme.spacing(1)
    },
    "& > *:not(:last-child)": {
      marginRight: theme.spacing(1)
    },
    [theme.breakpoints.up("md")]: {
      display: "flex",
      justifyContent: "center"
    }
  },
  comment: {
    marginBottom: theme.spacing(3),
    maxWidth: "900px",
    margin: "0 auto"
  }
}));

function ChooseProduct({
  focus,
  onSelect,
  ref,
  selectedProduct,
  setSelectedProduct
}) {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <Query query={PRODUCTS_QUERY}>
      {({ data, loading, error, refetch }) => {
        if (loading) {
          return (
            <div className="flex w-100">
              <Loader />
            </div>
          );
        }

        if (error) {
          return (
            <div className="flex w-100">
              <div>{t("root.error")}</div>
            </div>
          );
        }

        const options = orderBy(
          data.products.map(({ id, name }) => ({
            id,
            name,
            translation: t(`names.products.${name}`)
          })),
          "translation",
          "desc"
        );

        return (
          <>
            <h2>{t("categories.product")}</h2>
            <div className={classes.comment}>
              {t("creator.hint.product")}
            </div>
            <div className={classes.root}>
              <Dropdown
                focus={focus}
                options={options}
                label={t("creator.choose produkt")}
                onChange={newValue => {
                  setSelectedProduct(newValue);
                  onSelect();
                }}
                ref={ref}
                translationKey="names.products"
              />
            </div>
          </>
        );
      }}
    </Query>
  );
}

export const PRODUCTS_QUERY = gql`
  query ProductsQuery {
    products {
      id
      name
    }
  }
`;

export default ChooseProduct;
